//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  isEmpty
} from "@/utils/validate";
export default {
  name: "tourist.vue",
  async asyncData({ query, error, $axios }) {
    try {
      let type = query && query.type ? query.type : "1";
      let text = query && query.text ? query.text : "";
      return{
        searchText: text,
        searchType: type,
        trademarkNumber: type == 3 ? text : ''
      }

    } catch (err) {
      error(err);
    }
  },
  data(){
    return {
      isLogin: false, // 是否登录
      noDateHeight:'700',
      currentPage: 1,
      pageSize: 50,
      totalCont: 0,
      listLoading: true,
      tableData:[],
      dialogLoginTip: false,
      menuAlike: {
        typeSelect: [],
        classSelect: []
      } // 近似查询初始值
    }
  },
  created(){
    const _menuAlike = this.$cookies.get("menuAlike");
    if(this.$route.query.text && _menuAlike != null) this.filterConfirmAlike(_menuAlike);
    else this.$cookies.set("menuAlike", null);
  },
  mounted() {
    //无数据图片高度
    this.noDateHeight = document.documentElement.clientHeight - 140 + "px";
    let token = localStorage.getItem("uc_token");
    if (!isEmpty(token) && token !== "undefined" && token !== "null") {
      this.isLogin = true;
      // 登录跳转页面
      return this.$router.push(
        this.tools.trademarkSearchUrl(this.searchText, this.searchSelect)
      );
    } else {
      this.isLogin = false;
      localStorage.setItem("uc_token", "");
    }
    this.getList();
  },
  methods: {
    handleSizeChange(val){
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getList();
    },
    filterConfirmAlike(param){
      // param typeSelect,classSelect
      this.menuAlike = param;
    },
    getList(){
      this.listLoading = true;
      let JSONDATA = {
        keyword: this.searchText,
        searchType: this.searchType,
        code: this.trademarkNumber, //商标号
        menu: '',
        page: this.currentPage,
        num: this.pageSize,
      }
      if(this.searchType == '1' && this.menuAlike.typeSelect.length > 0){
        JSONDATA.menu = this.menuAlike.typeSelect.join(",");
        JSONDATA.classIds = this.menuAlike.classSelect;
      }
      this.$axios.post("/api/init/visitorSearch", JSONDATA).then(res => {
        console.log(res)
        const backData = res.data.data;
        this.tableData = backData.rows;
        this.totalCont = backData.total;
        this.listLoading = false;

      })
    },
    jumpLogin(){
      this.dialogLoginTip = true
    }

  }
}
